import React from 'react';
import type { TFunction } from 'i18next';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { GetOneToolTeamDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { TKeys, useTranslation } from '../../../common/hooks/useTranslation';

interface OneToolTeamSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  refresh?: boolean;
}

export const oneToolTeamForGrid = (
  t: TFunction<'administrationLng', 'administrationLng'>,
  tk: TKeys<'administrationLng'>,
  team: GetOneToolTeamDto,
) => ({
  key: team.id,
  values: {
    'oneToolTeam.oneToolId': team.oneToolId,
    'oneToolTeam.name': team.name,
    one_tool_team_active_yes_no: team.active
      ? t(tk.common.yesUpperCase)
      : t(tk.common.noUpperCase),
  },
});

export const OneToolTeamSearch: React.FC<OneToolTeamSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    {
      header: t(tk.administration.oneToolId),
      property: 'oneToolTeam.oneToolId',
    },
    { header: t(tk.common.name), property: 'oneToolTeam.name' },
    { header: t(tk.common.activeHe), property: 'one_tool_team_active_yes_no' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="oneToolTeam.name"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.administration.noOneToolTeams)}
      refresh={props.refresh}
      withFilterInColumns={true}
    />
  );
};
